import { countryCodes } from "../../helper/countryCodes";

export const countryOptions = countryCodes.map(c => ({
    value: c.dialCode,
    label: `${c.name} (${c.dialCode})`,
    iso2: c.iso2,
    flag: c.flag
}));

export const formatOptionLabel = (option) => (
    <div style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }}>
        <img src={option.flag} width={14} height={14} alt="" />
        <span>{option.label}</span>
    </div>
);
export const customStyles = {
    control: (base) => ({
        ...base,
        fontSize: "10px",
    }),
    valueContainer: (base) => ({
        ...base,
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        fontSize: "8px",
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "28px",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: "4px",
    }),
    menu: (base) => ({
        ...base,
        fontSize: "8px",
        zIndex: 9999,
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: "200px",
        overflowY: "auto",
        overflowX: "hidden",
    }),
    option: (base) => ({
        ...base,
        padding: "6px",
        fontSize: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
};